import GiftsLayout from 'components/gifts-table/GiftsLayout';

export default function withLayout(Component) {
  return (props = {}) => (
      <GiftsLayout>
        <Component {...props} />
      </GiftsLayout>
    );
}
